import React from "react";
import "./SupportSection.scss";

const SupportSection = ({ color = "#000", lineHeight = "4px" }) => {
  return (
    <div
      className="arrow-line"
      style={{
        "--color": color,
        "--lineHeight": lineHeight,
        "--arrowSize": "50px",
      }}
    >
      <div className="arrow-line__arrow"></div>
      <div className="arrow-line__line"></div>
    </div>
  );
};

export default SupportSection;
